import React, { useState } from "react";
import { useLocation, useNavigate, Link as RouterLink } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  CircularProgress,
  Link,
  IconButton,
  InputAdornment,
  Divider,
  Avatar,
} from "@mui/material";
// import GoogleIcon from "@mui/icons-material/Google";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
// import GoogleLogo from "../assets/google-icon.png";
import { signInWithEmailAndPassword } from "firebase/auth";

// Replace with your croissant/mascot image
import CroissantImg from "../assets/Full_icon.png";
import { auth, googleProvider } from "../firebase";
import { signInWithPopup } from "firebase/auth";


function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const landingData = location.state || {};

  const handleSignup = async (e) => {
  e.preventDefault();
  setLoading(true);
  try {
    await signInWithEmailAndPassword(auth, email, password);
    navigate("/");
  } catch (err) {
    console.error("Login error:", err);
    alert(err.message);
  } finally {
    setLoading(false);
  }
};

const handleGoogleSignup = async () => {
  setLoading(true);
  try {
    await signInWithPopup(auth, googleProvider);
    navigate("/"); // redirect after login
  } catch (err) {
    console.error("Google login error:", err);
    alert(err.message);
  } finally {
    setLoading(false);
  }
};



  return (
    <Box
      // minHeight="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      sx={{ marginTop:10 }}
    >
      <Box position="relative" width={420}>
        {/* Circular icon overlapping the card */}
        <Box
          sx={{
            position: "absolute",
            top: -40,
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 2,
            bgcolor: "#f9fafb",
            width: 80,
            height: 80,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          }}
        >
          <Avatar
            src={CroissantImg}
            alt="Croissant"
            sx={{
              width: 60,
              height: 60,
              bgcolor: "transparent",
            }}
          />
        </Box>

        <Card
          sx={{
            borderRadius: 4,
            boxShadow: "0 20px 50px rgba(0,0,0,0.12)",
            bgcolor: "#fff",
            pt: 2,
          }}
        >
          <CardContent sx={{ p: 4 }}>
            <Box textAlign="center" mb={3}>
              <Typography variant="h6" fontWeight={700}>
                Welcome Back!
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Sign in to your account
              </Typography>
            </Box>

            <Box component="form" onSubmit={handleSignup}>
              <TextField
                placeholder="Enter your email"
                type="email"
                fullWidth
                margin="normal"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EmailOutlinedIcon sx={{ color: "#6b7280" }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                  },
                }}
              />

              <TextField
                placeholder="Enter your password"
                type={showPassword ? "text" : "password"}
                fullWidth
                margin="normal"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockOutlinedIcon sx={{ color: "#6b7280" }} />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                  },
                }}
              />

              <Box textAlign="right" mt={1} mb={2}>
                <Link href="#" underline="hover" fontSize="0.9rem">
                  Forgot password?
                </Link>
              </Box>

              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{
                  mt: 1,
                  py: 1.25,
                  fontWeight: 700,
                  borderRadius: 2,
                  bgcolor: "#2563eb",
                  "&:hover": { bgcolor: "#1d4ed8" },
                }}
                disabled={loading}
              >
                {loading ? <CircularProgress size={22} color="inherit" /> : "Sign In"}
              </Button>
            </Box>

            <Typography
              variant="body2"
              textAlign="center"
              mt={3}
              color="text.secondary"
            >
              Don’t have an account?{" "}
              <Link
                component={RouterLink}
                to="/signup"
                underline="none"
                fontWeight={700}
                sx={{ color: "#2563eb" }}
              >
                Sign Up
              </Link>
            </Typography>

            <Divider sx={{ my: 3 }}>Or</Divider>

<Button
  fullWidth
  variant="outlined"
  onClick={handleGoogleSignup}
  sx={{
    py: 1.2,
    textTransform: "none",
    fontWeight: 600,
    borderColor: "#e5e7eb",
    color: "#111827",
    bgcolor: "#fff",
    borderRadius: 2,
    "&:hover": {
      bgcolor: "#f9fafb",
      borderColor: "#d1d5db",
    },
  }}
  startIcon={
    <Box
      sx={{
        width: 22,
        height: 22,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: "bold",
        fontSize: "0.9rem",
        background: `
          conic-gradient(
            #4285F4 0deg 90deg,   /* Blue */
            #34A853 90deg 180deg, /* Green */
            #FBBC05 180deg 270deg,/* Yellow */
            #EA4335 270deg 360deg /* Red */
          )
        `,
        color: "#fff",
      }}
    >
      G
    </Box>
  }
>
  Sign in with Google
</Button>

          </CardContent>
        </Card>
      </Box>
    </Box>
  );
}

export default Login;
